export default "__VITE_ASSET__DgH6vyxY__"